export const SET_WIDGET_INFO = "SET_WIDGET_INFO";
export const SET_FREE_SLOTS = "SET_FREE_SLOTS";
export const SET_STEPS = "SET_STEPS";
export const SET_PLACE = "SET_PLACE";
export const SET_MANY_PLACES = "SET_MANY_PLACES";

export const SUCCESS_NOTIFICATION = "SUCCESS_NOTIFICATION";
export const ERROR_NOTIFICATION = "ERROR_NOTIFICATION";
